import type {FeatureSourceData, RefreshRequest, RefreshResponse, RetrieveLabelsResponse} from '@/services/RefreshService/types';
import {backend, ownPublicApi} from './client';

export interface SharedMapsUser {
  uid: string;
  email?: string;
  displayName?: string;
}

// Mounted on both public APIs, so each app calls its own.
export const getSharedMapsUsers = async (options: {forceTokenRefresh?: boolean} = {}): Promise<SharedMapsUser[]> => {
  return backend.get<SharedMapsUser[]>(ownPublicApi(), {path: 'api/shared-maps/users', ...options});
};

// Refresh Features dialog: what each marker's Beyond Maps source offers today, checked as exported.
// Shareable Maps only; the route reads the paired Beyond Maps project server-side.
export const retrieveFieldLabels = async (
  features: Record<string, FeatureSourceData>,
): Promise<RetrieveLabelsResponse> => {
  return backend.post<RetrieveLabelsResponse>('external-public-api', {features}, {path: 'api/shared-maps/field-labels'});
};

// Rewrites the map's markers from their Beyond Maps sources with the dialog's selections and order.
export const refreshFeatures = async (request: RefreshRequest): Promise<RefreshResponse> => {
  return backend.post<RefreshResponse>('external-public-api', request, {path: 'api/shared-maps/refresh-features'});
};
